import $axios from '@/plugins/axios-instance'

export default {
    state: {

    },

    getters: {

    },

    actions: {

        aboutGet(context, type = 0) {
            return  $axios.get(`/Page/Get?PageType=${type}`)
            .then((response) => {
                return response.data + ''
            }).catch((e)=>{
                throw(e.response)
            })
        },


        aboutCreateOrUpdate(context, data) {
            return  $axios.post('/Page/CreateOrUpdate', data, {
                headers: {
                "Content-Type": "application/json"
                }
            })
            .then((response) => {
                return response.data
            }).catch((e)=>{
                throw(e.response)
            })
        },


    }
}